export const generateSlug = (text = '') => {
    return text
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .trim();
};

const UNKNOWN_COUNTRY_FALLBACK = 'unknown-country';
const UNKNOWN_FIRM_FALLBACK = 'unknown-firm';
const UNKNOWN_COMPANY_FALLBACK = 'unknown-company';
const UNKNOWN_ORGANIZATION_FALLBACK = 'unknown-organization';

const generateInstitutionRouteSegments = ({
    institutionName = '',
    countryName = '',
    countryId = null,
    institutionId = null,
    institutionFallback = 'unknown-institution',
} = {}) => {
    const institutionSlug =
        generateSlug(institutionName) ||
        (institutionId != null ? String(institutionId) : institutionFallback);
    const countrySlug =
        generateSlug(countryName) ||
        (countryId != null ? String(countryId) : UNKNOWN_COUNTRY_FALLBACK);

    return {
        institutionSlug,
        countrySlug,
        fullSlug: `${countrySlug}/${institutionSlug}`,
    };
};

export const generateFirmRouteSegments = ({
    institutionName = '',
    countryName = '',
    countryId = null,
    firmId = null,
} = {}) => {
    const { institutionSlug, countrySlug, fullSlug } = generateInstitutionRouteSegments({
        institutionName,
        countryName,
        countryId,
        institutionId: firmId,
        institutionFallback: UNKNOWN_FIRM_FALLBACK,
    });

    return {
        firmSlug: institutionSlug,
        countrySlug,
        fullSlug,
    };
};

export const generateCompanyRouteSegments = ({
    institutionName = '',
    countryName = '',
    countryId = null,
    companyId = null,
} = {}) => {
    const { institutionSlug, countrySlug, fullSlug } = generateInstitutionRouteSegments({
        institutionName,
        countryName,
        countryId,
        institutionId: companyId,
        institutionFallback: UNKNOWN_COMPANY_FALLBACK,
    });

    return {
        companySlug: institutionSlug,
        countrySlug,
        fullSlug,
    };
};

export const generateOrganizationRouteSegments = ({
    institutionName = '',
    countryName = '',
    countryId = null,
    organizationId = null,
} = {}) => {
    const { institutionSlug, countrySlug, fullSlug } = generateInstitutionRouteSegments({
        institutionName,
        countryName,
        countryId,
        institutionId: organizationId,
        institutionFallback: UNKNOWN_ORGANIZATION_FALLBACK,
    });

    return {
        organizationSlug: institutionSlug,
        countrySlug,
        fullSlug,
    };
};

export default generateSlug;
